import { PaymentMethodType, PaymentTransactionStatus } from "../enums";  
import { SystemColor, SystemColorsModel } from "../models";

export class PaymentUtil {
    static getColorsByStatus(status: keyof typeof PaymentTransactionStatus): SystemColor {
        let colors = SystemColorsModel.lightGreyColors();
        switch (status) {
            case 'Paid':
                colors = SystemColorsModel.ligthGreenColors();
                break;
            case 'Failed':
                colors = SystemColorsModel.lightRedColor();
                break;
            case 'Cancelled':
                colors = SystemColorsModel.lightGreyColors();
                break;
            case 'InProcess':
                colors = SystemColorsModel.lightBlueColor();
                break;
            case 'Scheduled':
                colors = SystemColorsModel.lightBlueColor();
                break;
            case 'Refund':
                colors = SystemColorsModel.ligthPurpleColors();
                break;
        }
        return colors;
    }
}

export const GetPaymentMethodType = (type: keyof typeof PaymentMethodType) => {
    switch (type) {
        case 'Card':
            return 'Card';
        case 'Bank':
            return 'Bank Account';
        default:
            return type;
    }
};
